module.exports = __webpack_public_path__ + "img/loads.b191a68c.png";